import React, { useEffect, useState } from 'react';
import $ from 'jquery';
import Bank from '../../../../../constants/models/servicePayloads/bank';
import BankAccount from '../../../../../constants/models/servicePayloads/bankAccount';
import * as R from 'ramda';

export const CardColumn = ({ n, cardType, isMain, globalPayload, setGlobalPayload }) => {
    const [bankAccount, setBankAccount] = useState(new BankAccount({accountType: cardType.accountType, comment: '', number: '', colNum: n}));

    function changePayload(remove, _bankAccount) {
        let tmpAccounts = !R.isNil(globalPayload.payload) ? globalPayload.payload.accounts.map((a) => {
            let elementsFromColumn = globalPayload.payload.accounts.filter(aa => aa.accountType === cardType.accountType);
            let myElementIndex = elementsFromColumn.findIndex(e => e === a);
            return {...a,
            colNum: myElementIndex
        }}) : [];
        let currentCol = tmpAccounts.findIndex(a => !R.isNil(a.colNum) && a.colNum === n && a.accountType === cardType.accountType);

        if (currentCol !== -1 && remove === true){
            tmpAccounts = tmpAccounts.filter((a,i) => i !== currentCol);
        }
        else{
            if (currentCol === -1) {
                tmpAccounts.push(_bankAccount);
            }
            else {
                tmpAccounts[currentCol] = _bankAccount;
            }
        }
        setGlobalPayload({...globalPayload, payload: new Bank({ isMain: isMain, accounts: tmpAccounts })});
    };

    useEffect(() => {
        let accountsFromAllColumns = !R.isNil(globalPayload.payload) ? globalPayload.payload.accounts.filter(a => a.accountType === cardType.accountType): undefined;
        if (!R.isNil(accountsFromAllColumns) && accountsFromAllColumns.length >= n && !R.isNil(accountsFromAllColumns[n])) {
            let columnAccount = JSON.parse(JSON.stringify(accountsFromAllColumns[n]));
            setBankAccount({ ...bankAccount, comment: columnAccount.comment, number: columnAccount.number });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        $('[data-toggle="tooltip"]').tooltip();
    }, []);
    
    return (
        <div className="card-body py-3 flex-column col">
            <div className="form-group mb-auto">
                <div className="flex-row gx-2 align-items-center mb-1">
                    <label htmlFor={cardType.name + n} className="label my-auto h6 font-weight-bold">Numéro de compte</label>
                    <p className="form-text small text-gray my-auto ml-auto" data-toggle="tooltip" data-placement="top" data-html="true" data-template='<div class="tooltip" role="tooltip"><div class="arrow"></div><div class="tooltip-inner px-3 py-2 fs-2"></div></div>' title="Une référence permet à vos organismes de vous identifier afin de faire les démarches nécessaires."><i className="eva eva-info-outline mr-1 fs-sm lh-root align-middle"></i></p>
                </div>
                <input type="text" className="form-control" id={cardType.name + n} placeholder="xxxxxxxxxxx" value={bankAccount.number} onChange={(e) => {
                    e.preventDefault();
                    let tmpBankAccount = {...bankAccount, number: e.target.value};
                    setBankAccount(tmpBankAccount);
                    changePayload(null, tmpBankAccount);
                }} />
            </div>
            <div className="form-group mt-auto mb-0">
                <div className="flex-row gx-2 align-items-center mb-1">
                    <label className="h6 font-weight-bolder my-auto" htmlFor={cardType.name + 'Comment' + n}>Votre commentaire</label>
                    <p className="form-text small text-gray my-auto ml-auto" data-toggle="tooltip" data-placement="top" data-html="true" data-template='<div class="tooltip" role="tooltip"><div class="arrow"></div><div class="tooltip-inner px-3 py-2 fs-2"></div></div>' title="Les cases commentaires sont personnelles (ne seront pas visibles par le référent), elles vous permettent d'ajouter des notes à vos services."><i className="eva eva-info-outline mr-1 fs-sm lh-root align-middle"></i></p>
                </div>
                <textarea className="form-control no-resize" placeholder="" id={cardType.name + 'Comment' + n} name={cardType.accountType+"Nombre" + n} value={bankAccount.comment} onChange={(e) => {
                      let tmpBankAccount = {...bankAccount, comment: e.target.value};
                    setBankAccount(tmpBankAccount);
                    changePayload(null, tmpBankAccount);
                }} ></textarea>
            </div>

            <div className="input-group mb-0">
                <div className="block mt-3">
                    {
                        bankAccount.comment !== '' || bankAccount.number !== '' ?
                            <span className="btn-alert-danger border-none px-2 py-2 rounded ml-1" id={cardType.accountType+"basic-addon2"+n} onClick={(e) => {
                                e.preventDefault();
                                setBankAccount({...bankAccount, comment: '', number: ''});
                                changePayload(true);
                            }}><i className="eva eva-trash-outline"></i></span> : ''
                    }
                </div>
            </div>
        </div>
    )
}